import { BlurBackgroundController, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { Bitmap, Linear, dispatcher, ingenuity } from "@quest/base-core";
import { IEvent, ITween } from "@quest/adapter-interface";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class BlurBackgroundControllerGame extends BlurBackgroundController {
  protected freeGameOutroBG: Bitmap;
  protected freeGameIntroBG: Bitmap;
  protected selectionBlurBg: Bitmap;
  protected bigWinBG: Bitmap;

  protected subscribeEvents(): void {
    this.unSubscribeEvents();
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.HIDE_BLUR_BG, this.hideBlurBG, this);
  }
  protected unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.HIDE_BLUR_BG, this.hideBlurBG, this);
  }

  /**
   * This method is use to change background
   */
  protected changeBackground(evt: IEvent): void {
    super.hideAllBg();
    if (evt.data === gameConstants.FULLSCREEN_BIGWIN_BG) {
      if (this.bigWinBG) {
        this.bigWinBG = null;
      }
      this.bigWinBG = this.view.getImageById("bigwinBlurImage");
      this.showBlurBG(this.bigWinBG);
    } else if (evt.data === gameConstants.FREEGAME_INTRO_BG) {
      if (this.freeGameIntroBG) {
        this.freeGameIntroBG = null;
      }
      this.showBaseGameBlurBg();
      this.freeGameIntroBG = this.view.getImageById("FreegameIntroBlurImage");
      this.showBlurBG(this.freeGameIntroBG);
    } else if (evt.data === SlotConstantsBehavior.SELECTION_SCREEN_BG_SHOW) {
      if (this.selectionBlurBg) {
        this.selectionBlurBg = null;
      }
      this.selectionBlurBg = this.view.getImageById("SelectionBlurImage");
      this.showBlurBG(this.selectionBlurBg);
    } else {
      super.changeBackground(evt);
    }
  }
  /**
   * hide extra banners
   */
  protected hideAllBg(): void {
    super.hideAllBg();
    this.bigWinBG && (this.bigWinBG.visible = false);
    this.freeGameIntroBG && (this.freeGameIntroBG.visible = false);
    this.freeGameOutroBG && (this.freeGameOutroBG.visible = false);
  }
  /**
   * function to show Bigwin bg
   */
  private showBlurBG(blurBG: Bitmap): void {
    let backgroundBlurBG: Bitmap = blurBG;
    backgroundBlurBG.visible = true;
    backgroundBlurBG.alpha = gameConstants.ALPHA_0;
    let appearBlurBG: ITween = ingenuity.currentGame.add.tween(backgroundBlurBG);
    appearBlurBG.to({ alpha: 1 }, 500, Linear.None, true);
    appearBlurBG.onComplete.add(() => {
      ingenuity.currentGame.tweens.remove(appearBlurBG);
    }, this);
  }

  /**
   * function to hide bigwin bg
   */
  private hideBlurBG(evt: IEvent): void {
    let backgroudImage: Bitmap = null;
    if (evt.data.name === gameConstants.FULLSCREEN_BIGWIN_BG) {
      backgroudImage = this.bigWinBG;
    } else if (evt.data.name === gameConstants.FREEGAME_INTRO_BG) {
      backgroudImage = this.freeGameIntroBG;
    } else if (evt.data.name === SlotConstantsBehavior.SELECTION_SCREEN_BG_SHOW) {
      backgroudImage = this.selectionBlurBg;
    }
    const hideBG: any = ingenuity.currentGame.add.tween(backgroudImage);
    hideBG.to({ alpha: gameConstants.ALPHA_0 }, evt.data.duration, Linear.None, true);
    hideBG.onComplete.add(() => {
      backgroudImage.visible = false;
      ingenuity.currentGame.tweens.remove(hideBG);
    }, this);
  }
}
